import { Div, DivProps, Span } from '@kizi/core-components';
import { IconV2 as Icon, IconV2, withTooltip } from '@kizi/shared-components';
import React from 'react';
import { isMobile } from '../utils/global';

const IconWithTooltip = withTooltip(IconV2);

export interface RequirementProps extends DivProps {
  iconName: string;
  value: string;
  label: string;
  tooltip?: string;
}

export const Requirement: React.FC<RequirementProps> = ({
  iconName,
  value,
  label,
  tooltip,
}: RequirementProps) => {
  return (
    <Div
      width={isMobile() ? 'auto' : '125px'}
      maxHeight="32px"
      borderRadius="48px"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      variant="requirement"
      padding="4px 8px"
      minHeight="20px"
    >
      <Div display="flex" alignItems="center">
        <Icon
          mr="4px!important"
          name={iconName}
          width={16}
          height={17}
          fill="main.2"
        />
        <Div display="flex" flexDirection="column">
          <Span
            color={'main.2'}
            fontFamily="heading"
            fontSize={2}
            fontWeight={1}
          >
            {value}
          </Span>
          <Span
            color={'supplementary.7'}
            fontFamily="heading"
            fontSize={isMobile() ? '8px' : '10px'}
          >
            {label}
          </Span>
        </Div>
      </Div>
      {tooltip && (
        <IconWithTooltip
          name="info"
          size={14}
          css={{ fill: '#D9DADE', marginRight: '0!important' }}
          _tooltip={tooltip}
          cursor="pointer"
        />
      )}
    </Div>
  );
};
